module.exports = __webpack_public_path__ + "38b326ec39c4876860701a9388ea3331.mp3";